import { css, html } from 'react-strict-dom';

import { Style } from '../constants';
import { color } from '../constants/color.css';
import Skeleton from './Skeleton';

/** App-bootstrap loader, shown before the shell (and its layout) exists. */
export default function AppLoading() {
  return (
    <html.div
      aria-label="Loading M10c Hub"
      aria-live="polite"
      role="status"
      style={[Style.col, Style.centerBoth, styles.wrap]}
    >
      <img alt="" src="/img/logo_new.svg" style={{ height: 24 }} />
      <Skeleton width={140} height={12} />
    </html.div>
  );
}

const styles = css.create({
  wrap: {
    minHeight: '100vh',
    backgroundColor: color.neutral5,
    gap: 16,
    padding: 24,
  },
});
